import React, { ReactNode } from 'react';
import { AlertDialogBody } from '@chakra-ui/react';

interface Props {
  children: ReactNode;
}

export const AlertBody = ({ children }: Props): JSX.Element => {
  return <AlertDialogBody>{children}</AlertDialogBody>;
};
export type { Props as AlertBodyProps };
